import { render, staticRenderFns } from "./PostAdjustment.vue?vue&type=template&id=a720c6c0"
import script from "./PostAdjustment.vue?vue&type=script&lang=js"
export * from "./PostAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports